import { VideoControlWrapper as VideoControl } from "../../session/controls/VideoControl";
import { useOpenHelpModalCallback } from "../useOpenHelpModalCallback";

export function VisitorVideoControlWrapper() {
  const openHelpModal = useOpenHelpModalCallback();

  return <VideoControl openHelpModal={openHelpModal} />;
}
